import SiteListView from './SiteListView';
import './SiteListView.scss';

export default SiteListView;
